export default class ObservationDataStore {
  constructor() {
    this.danger = {
      snowdriftSize: null,
      whumpfCracksFrequency: null,
      dangerOf: null,
      aspectFrom: null,
      aspectTo: null,
      altitudeAbove: null,
      altitudeValue: null,
      level: null,
    };
  }
  getAspectFrom() {
    return this.danger.aspectFrom;
  }
  setAspectFrom(aspect) {
    this.danger.aspectFrom = aspect;
  }
  getAspectTo() {
    return this.danger.aspectTo;
  }
  setAspectTo(aspect) {
    this.danger.aspectTo = aspect;
  }
  setWhumpfCracksFrequency(whumpfCracksFrequency) {
    this.danger.whumpfCracksFrequency = whumpfCracksFrequency;
  }
  getWhumpfCracksFrequency() {
    return this.danger.whumpfCracksFrequency;
  }
  setSnowdriftSize(snowdriftSize) {
    this.danger.snowdriftSize = snowdriftSize;
  }
  getSnowdriftSize() {
    return this.danger.snowdriftSize;
  }
  setDangerOf(dangerOf) {
    this.danger.dangerOf = dangerOf;
  }
  getDangerOf() {
    return this.danger.dangerOf;
  }
  setAltitudeAbove(altitudeAbove) {
    this.danger.altitudeAbove = altitudeAbove;
  }
  getAltitudeAbove() {
    return this.danger.altitudeAbove;
  }
  setAltitude(altitudeValue) {
    this.danger.altitudeValue = altitudeValue;
  }
  getAltitude() {
    return this.danger.altitudeValue;
  }
  setLevel(level) {
    this.danger.level = level;
  }
  getLevel() {
    return this.danger.level;
  }
  isAspectValid() {
    if (this.danger.aspectFrom || this.danger.aspectTo) {
      // if aspect from or to is set, the other must be set too
      if (!(this.danger.aspectFrom && this.danger.aspectTo)) {
        return false;
      }
    }
    return true;
  }
  isAltitudeValid() {
    const dan = this.danger;
    if (dan.altitudeAbove != null || dan.altitudeValue != null) {
      // if altitudeAbove or altitudeValue is set, the other must be set too
      if (!(dan.altitudeAbove != null && dan.altitudeValue != null)) {
        return false;
      }
    }
    return true;
  }
  // eslint-disable-next-line complexity
  isMinimalContentSet() {
    return (
      this.danger.whumpfCracksFrequency != null ||
      this.danger.snowdriftSize != null ||
      this.danger.dangerOf != null ||
      (this.danger.altitudeAbove != null &&
        this.danger.altitudeValue != null) ||
      this.danger.level != null ||
      (this.danger.aspectFrom != null && this.danger.aspectTo != null)
    );
  }
}
